<template>
  <v-container class="pa-1">
    <!-- <v-layout justify-space-around row>
      <v-flex>
        <v-card class="dashBlock">
          <v-layout justify-space-between row>
            <v-flex>
              <p>Amount orders</p>
              <p class="numTitle">--</p>
            </v-flex>

            <v-flex>
              <p>Complete</p>
              <p style="color:green;">-</p>
              <p>Cancel</p>
              <p style="color:red;">-</p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total Revenue</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total Transfer</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total Promotion</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
    </v-layout> -->

    <v-layout row>
      <v-flex>
        <v-btn
          color="#FFD600"
          class="btnReport"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/store_report'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Sale store report</span>
        </v-btn>
        <v-btn
          color="#FFD600"
          class="btnReport"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/store_payment'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Store payment report</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>

<script>
export default {
  computed: {},
};
</script>
